import { render, staticRenderFns } from "./scorecard-order-settings.vue?vue&type=template&id=df751208&scoped=true"
import script from "./scorecard-order-settings.vue?vue&type=script&lang=js"
export * from "./scorecard-order-settings.vue?vue&type=script&lang=js"
import style0 from "./scorecard-order-settings.vue?vue&type=style&index=0&id=df751208&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df751208",
  null
  
)

export default component.exports